import React, { useState, useEffect } from 'react';
import { CustomModal } from '../../../utils/components/CustomModal';
import { focusInput } from '../../../utils/helpers';
import Loader from '../../../assets/components/loader';

const LoginModal = ({
  modalTitle,
  changeModalState,
  handleInputChange,
  handleOnfocus,
  user,
  onSave,
  loading,
  checkOTP,
  requestOtp,
  requestOtpFunction
}) => {

  const inputStatus = (key) => {
    if (user[key].focused) {
      if (user[key].error === "") {
        return "input--group input--success"
      } else {
        return "input--group input--error"
      }
    } else {
      return "input--group"
    }
  }

  return(
    <CustomModal
      modalTitle={modalTitle}
      changeModalState={changeModalState}
      onSave={onSave}
      loading={loading}
      submitButtonLabel={checkOTP === true ? "Proceed":"Verify"}
      disableSubmitButton={checkOTP === true ?
        (user.otp.error === "" && user.otp.value !== "" ? false : true):
        (user.email.error === "" && user.email.value !== "" ? false : true)}
      width="500px"
      >
      <div className="marquet--form--group">
        <div onClick={ev => focusInput(ev)} className={inputStatus("email")}>
          <label>
            EMAIL<b> *</b>
          </label>
          <input
            name="email"
            type="email"
            maxLength={50}
            disabled={checkOTP === true ? true:false}
            onChange={ev => handleInputChange(ev)}
            onFocus={ev => handleOnfocus(ev)}
            value={user.email.value} />
        </div>
        <div className="invalid--feedback">{user.email.error}</div>
      </div>
      {checkOTP === true &&
        <>
          <div className="marquet--form--group">
          <div onClick={ev => focusInput(ev)} className={inputStatus("otp")}>
              <label>
                One Time Password<b> *</b>
              </label>
              <input
                name="otp"
                type="text"
                onChange={ev => handleInputChange(ev)}
                onFocus={ev => handleOnfocus(ev)}
                value={user.otp.value} />
            </div>
            <div className="invalid--feedback">{user.otp.error}</div>
          </div>
        <div className="marquet--button--group">
          <button className="custom--links" onClick={ev => requestOtpFunction(ev)} disabled={requestOtp? true: false}>
            {requestOtp && <Loader size="xs"/>}
            Request for a new OTP
          </button>
        </div>
        </>
      }
    </CustomModal>
  )
}

export default LoginModal;